<template>
    <div class="feedbackReport">
        <BackButton />
        <v-container style="max-width:1000px">

            <div v-if="dbLoaded" class="white--text">
                <div class="mb-1 text-center">
                    <!-- <h2>Feedback Report</h2> -->
                    <div v-if="user.type==='artist'">
                        <h2 class="syn_blue_button--text">{{submission.song_title}}</h2>
                    </div>
                    <div v-else-if="user.type==='user'">
                        <router-link class="rl-no-dec" :to="{ name: 'Song', params: { songId: submission.song_id }}"><h2 class="syn_blue_button--text">{{submission.song_title}}</h2></router-link>
                    </div>
                    
                    <v-avatar v-if="artist" size="100" class="my-2">
                        <v-img  :src="artist.avatar"></v-img>
                    </v-avatar>
                    <div>
                        <span class="synThinFont">Feedback by: </span><router-link class="rl-no-dec syn_blue_button--text" :to="{ name: 'Artist', params: { artistId: submission.artist_id }}">{{submission.artist_name}}</router-link>
                    </div>
                </div>
                <div class=" mb-5">
                    <br>
                    <div class="text-center">
                        <h2 class="synThickFont ">Overall</h2>
                        <FeedbackPercentage :rating="Math.round(submission.feedback.overall[0])" size="120" color="syn_blue_button"/>
                    </div>
                    <FeedbackComment class="criteriaCommentBox mb-5" :comment="submission.feedback.overall[1]" />
                    <div>
                        <!-- <div class="text-center separatorDiv"></div> -->
                        <v-row  class="my-5 py-3"> 
                            <v-col sm="6" xs="12">
                                <div class="text-center">
                                    <h3 class="synThickFont ">{{namings.mixingMastering}}</h3> 
                                    <FeedbackPercentage  :rating="Math.round(submission.feedback.mixingMastering[0])" size="100" color="primary"/>
                                </div>
                                <FeedbackComment  class="criteriaCommentBox " :comment="submission.feedback.mixingMastering[1]" />
                            </v-col>
                            <v-col sm="6" xs="12" >
                                <div class="text-center">
                                    <h3 class="synThickFont ">{{namings.toplines}}</h3> 
                                    <FeedbackPercentage  :rating="Math.round(submission.feedback.toplines[0])" size="100" color="primary"/>
                                </div>
                                <FeedbackComment class="criteriaCommentBox linkHoverSmall" :comment="submission.feedback.toplines[1]" />
                            </v-col>
                        </v-row>
                        <!-- <div class="text-center separatorDiv"></div> -->
                        <v-row class="my-5 py-3"> 
                            <v-col sm="6" xs="12">
                                <div class="text-center">
                                    <h3 class="synThickFont ">{{namings.drums}}</h3> 
                                    <FeedbackPercentage   :rating="Math.round(submission.feedback.drums[0])" size="100" color="primary"/>
                                </div>
                                <FeedbackComment class="criteriaCommentBox" :comment="submission.feedback.drums[1]" />
                            </v-col>
                            <v-col sm="6" xs="12" >
                                <div class="text-center">
                                    <h3 class="synThickFont ">{{namings.soundDesign}}</h3> 
                                    <FeedbackPercentage  :rating="Math.round(submission.feedback.soundDesign[0])" size="100" color="primary"/>
                                </div>
                                <FeedbackComment class="criteriaCommentBox" :comment="submission.feedback.soundDesign[1]" />
                            </v-col>
                        </v-row>
                        <!-- <div class="text-center separatorDiv"></div> -->
                        <v-row class="my-5 py-3"> 
                            <v-col sm="6" xs="12">
                                <div class="text-center">
                                    <h3 class="synThickFont ">{{namings.engagement}}</h3> 
                                    <FeedbackPercentage  :rating="Math.round(submission.feedback.engagement[0])" size="100" color="primary"/>
                                </div>
                                <FeedbackComment class="criteriaCommentBox" :comment="submission.feedback.engagement[1]" />
                            </v-col>
                            <v-col sm="6" xs="12" >
                                <div class="text-center">
                                    <h3 class="synThickFont ">{{namings.originality}}</h3> 
                                    <FeedbackPercentage  :rating="Math.round(submission.feedback.originality[0])" size="100" color="primary"/>
                                </div>
                                <FeedbackComment class="criteriaCommentBox" :comment="submission.feedback.originality[1]" />
                            </v-col>
                        </v-row>
                    </div>
                </div>
                
                
                


                <div class="text-right grey--text">
                    <i>Report ID: {{this.$route.params.submissionId}}</i>
                </div>

            </div>
            
        </v-container>
        <Overlay :overlay="overlay" />
    </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import fb from '@/fb'
import BackButton from '@/components/layout/BackButton'
// import FeedbackReportCarousel from '@/components/submissions/FeedbackReport/FeedbackReportCarousel'
import FeedbackPercentage from '@/components/submissions/FeedbackReport/FeedbackPercentage'
import FeedbackComment from '@/components/submissions/FeedbackReport/FeedbackComment'
import Overlay from '@/components/layout/Overlay'
// import 'easy-circular-progress/src/index';
const db = fb.db
const storage = fb.storage

export default {
    name: "FeedbackReport",
    components: {
        // FeedbackReportCarousel,
        FeedbackPercentage,
        FeedbackComment,
        BackButton,
        Overlay
    },
    data() {
        return {
            overlay:true,
            dbLoaded: false,
            submission: null,
            // overallPercentage: null,
            // ratings: null,
            // feedback: null,
            namings: {
                overall: 'Overall',
                mixingMastering: 'Mixing & Mastering',
                toplines: 'Melodies / Vocals',
                drums: 'Drums & Percussion',
                soundDesign: 'Sound Design',
                engagement: 'Engagement / Arrangement',
                originality: 'Originality'
            },
            
            interval: {},
            value:0,
            artist: null,
            user: null
        }
    },
    created() {
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                
                let ref = db.collection('users')


                // get current user
                ref.where('user_id','==',firebase.auth().currentUser.uid).get()
                .then(snapshot => {
                    snapshot.forEach(doc => {
                        this.user = doc.data(),
                        this.user.id = doc.id
                        this.user.email = user.email
                    })
                }).then(()=> {
                    // console.log(this.$route.params.submissionId);
                    let ref = db.collection('submissions').where(firebase.firestore.FieldPath.documentId(),'==',this.$route.params.submissionId)
                    ref.get().then(snapshot => {
                        snapshot.forEach(doc => {
                            this.submission = doc.data()
                            this.submission.id = doc.id
                        })
                    }).then(()=>{
                        // console.log(this.submission);
                        
                        // this.ratings = {
                        //     mixingMasteringRating: parseInt(this.submission.feedback.mixingMasteringRating),
                        //     marketAppealRating: parseInt(this.submission.feedback.marketAppealRating),
                        //     drumsRating: parseInt(this.submission.feedback.drumsRating),
                        //     soundDesignRating:  parseInt(this.submission.feedback.soundDesignRating),
                        //     engagementRating: parseInt(this.submission.feedback.engagementRating),
                        //     authenticityRating: parseInt(this.submission.feedback.authenticityRating)
                        // }

                        // for (let rating in this.ratings){
                        //     console.log(this.ratings[rating]);
                            
                        //     this.overallPercentage += (this.ratings[rating]/6);
                        // }
                        
                        // this.feedback = {
                        //     overall: [parseInt(this.overallPercentage),this.submission.feedback.overallComment],
                        //     mixingMastering: [parseInt(this.submission.feedback.mixingMasteringRating),this.submission.feedback.mixingMastering],
                        //     marketAppeal: [parseInt(this.submission.feedback.marketAppealRating),this.submission.feedback.marketAppeal],
                        //     drums: [parseInt(this.submission.feedback.drumsRating),this.submission.feedback.drums],
                        //     soundDesign:  [parseInt(this.submission.feedback.soundDesignRating),this.submission.feedback.soundDesign],
                        //     engagement: [parseInt(this.submission.feedback.engagementRating),this.submission.feedback.engagement],
                        //     authenticity: [parseInt(this.submission.feedback.authenticityRating),this.submission.feedback.authenticity]
                        // }
                        // console.log(this.feedback);
                        
                        
                        
                        
                        
                        // let total = this.mixingMasteringRating +  this.marketAppealRating+ this.drumsRating + this.soundDesignRating + 
                        // this.engagementRating + this.authenticityRating

                        // this.overallPercentage = total/6
                        
                        
                        
                    // }).then(()=>{
                        let artistRef = db.collection('artists').where(firebase.firestore.FieldPath.documentId(),'==',this.submission.artist_id)

                        artistRef.get().then(snapshot => {
                            snapshot.forEach(doc => {
                                storage.ref().child(doc.data().avatarPath).getDownloadURL().then(function(url) {
                                    return url
                                }).then((url)=>{
                                    this.artist = doc.data()
                                    this.artist.artist_id = doc.id
                                    this.artist.avatar= url
                                    this.overlay=false
                                    // console.log(this.artist);
                                })
                                
                            })
                        }).then(()=>{
                            this.dbLoaded=true
                        })
                        
                        
                        // if(this.overallPercentage){
                        //     console.log('hi');
                            
                        //     this.interval = setInterval(() => {
                        //         if (this.value === this.overallPercentage) {
                        //         //   return (this.value = 0)
                        //             return (this.value)
                        //         }
                        //         this.value += 1
                        //     }, 10)
                        // }
                    })
                    .catch((err) => {
                        console.log(err);
                    })
                })
                

                
                    
            } else {
                this.user = null
            }
        })
        
        
        
        
    },
    // beforeDestroy() {
    //     clearInterval(this.interval)
    // },

}
</script>

<style >
.cBox{
    position: relative;
    width: 150px;
    height: 150px;

}
.cPercent svg{
    position: relative;
    width: 150px;
    height: 150px;
}
.cPercent circle{
    width: 150px;
    height: 150px;
    fill: none;
    stroke-width: 10;
    stroke: #000;
    transform: translate(5px, 5px);
    stroke-dasharray: 440;
    stroke-dashoffset: 440;
    stroke-linecap: round;
}
.cPercent .circleEmpty{
    stroke-dashoffset: 0;
    stroke: #f3f3f3;
}
.cPercent .circleFull{
    /* stroke-dashoffset: calc(440 - (440*87)/100); */
    stroke: #03a9f4;
}

.cPercent .cNumber {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.cPercent .cNumber h2 {
    font-size: 48px;
}
.cPercent .cNumber h2 span{
    font-size: 24px;
}

.v-progress-circular {
    margin: 1rem;
}
.rl-no-dec{
    text-decoration: none;
}
.criteriaCommentBox{
    /* #05192B = rgb(5,25,43) */
    background-color: rgba(5,25,43,0.3); 
    border: rgba(255,255,255,0.3) 1px solid;
    border-radius:5px;
    padding: 10px 20px !important;
    margin-top: 10px !important;
    font-size: 0.9em !important;
}
.feedbackReport .separatorDiv{
    height:1px;
    width:100%;
    background-color: grey;
    margin-left: auto;
    margin-right: auto;
    border-radius: 5px;
}
</style>